import { RFC } from "../models/RFC";
import { type as types } from "../types/index";

const initialState = {isRFC: false, dataRFC: RFC};

export const RFCReducer = (state = initialState, action) => {

    const {type, payload } = action;
    switch (type) {
        case types.getRFC:
            const result = {
                ...state, 
                isRFC: true,
                dataRFC: payload
                
            };
            return result;
        case types.getRFCFail:
            return {
                ...state,
                isRFC: false,
                dataRFC: initialState
            }
        case types.resetRFC:
            const resetState = {
                ...state,
                isRFC: false,
                dataRFC: initialState
            }
            return resetState
        default:
            return state;
    }
}
